module.exports = __webpack_public_path__ + "static/media/bulk-attendance-template.1c9b1a6b.png";